<template>
    <DTable
        :items="serviceFees"
        :fields="fields"
    >
        <template #net_from="{item}">
            <td>
                {{ item.net_from !== null ? priceFormatForDisplay(item.net_from, 2, item.market_region.id) : '-' }}
            </td>
        </template>
        <template #price="{item}">
            <td>
                {{ priceFormatForDisplay(item.price, 2, item.market_region.id) }}
            </td>
        </template>
        <template #market_region="{item}">
            <td>
                {{ item.market_region.name }}
            </td>
        </template>
        <template #description="{item}">
            <td>
                {{ item.description ?? '' }}
            </td>
        </template>
    </DTable>
</template>

<script>
import priceFormat from '~@/Mixins/priceFormat'
export default {
    name: 'DetailsTable',
    mixins: [
        priceFormat
    ],
    props: {
        serviceFees: {
            type: Object,
            default: () => { return {} }
        }
    },
    data () {
        return {
            fields: [
                { key: 'name', label: this.__('tools.service_fees.table.name') },
                { key: 'description', label: this.__('tools.service_fees.table.description') },
                { key: 'net_from', label: this.__('tools.service_fees.table.net_from') },
                { key: 'price', label: this.__('tools.service_fees.table.price') },
                { key: 'market_region', label: this.__('tools.service_fees.table.market_region') }
            ]
        }
    }
}
</script>
